import { usePersistentFilters } from '@/stores/composables/usePersistentFilters';
import type { IStorageFiltersOptions } from '@/types';

export interface UseFilterPersistenceOptions<T extends object> {
    storeId: string;
    primaryStoreId: string;
    filters: T;
    saveFiltersState: Ref<boolean>;
    resetFilters: () => void;
    keysToPersist?: (keyof T)[];
    storageKeyPrefix?: string;
    transform?: IStorageFiltersOptions<T>['transform'];
}

export function useFilterPersistence<T extends object>(options: UseFilterPersistenceOptions<T>) {
    const { storeId, primaryStoreId, filters, saveFiltersState, resetFilters, keysToPersist, storageKeyPrefix, transform } = options;

    const isPrimaryStore = computed(() => storeId === primaryStoreId);

    const persistentFilters = usePersistentFilters({
        filters,
        keysToPersist,
        storageKeyPrefix,
        transform,
        enabled: computed(() => saveFiltersState.value && isPrimaryStore.value),
    });

    const reloadFiltersFromStorage = () => {
        resetFilters();
        if (isPrimaryStore.value && saveFiltersState.value) {
            persistentFilters.loadFromStorage();
        }
    };

    return {
        persistentFilters,
        reloadFiltersFromStorage,
    };
}
